module.exports = __webpack_public_path__ + "img/1439008396.b5d0c981.jpg";